/**
 * @generated SignedSource<<cf61c9c14aeb09c0fa78cfedd47098bb>>
 * @relayHash 73aba3cc8d8fbe4959ea70b9ac8f2691
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60e21a301c4777d050c0747f6038c7870a9d9fd532d67d8e0bb76572417aa641

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkforceOptimizationExperimentPageQuery } from './WorkforceOptimizationExperimentPageQuery.graphql';

const node: PreloadableConcreteRequest<WorkforceOptimizationExperimentPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "60e21a301c4777d050c0747f6038c7870a9d9fd532d67d8e0bb76572417aa641",
    "metadata": {},
    "name": "WorkforceOptimizationExperimentPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
